export const PLES = [
  { id: 'backlash', name: 'Backlash' },
  { id: 'clash-in-paris', name: 'Clash in Paris' },
  { id: 'crown-jewel', name: 'Crown Jewel' },
  { id: 'hell-in-a-cell', name: 'Hell in A Cell' },
  { id: 'money-in-the-bank', name: 'Money In The Bank' },
  { id: 'battleground', name: 'Battleground' },
  { id: 'evolution', name: 'Evolution' },
  { id: 'great-american-bash', name: 'Great American Bash' },
  { id: 'halloween-havoc', name: 'Halloween Havoc' },
  { id: 'night-of-champions', name: 'Night of Champions' },
  { id: 'no-mercy', name: 'No Mercy' },
  { id: 'worlds-collide', name: 'Worlds Collide' },
  { id: 'survivor-series', name: 'Survivor Series: War Games' },
  { id: 'summerslam', name: 'SummerSlam' },
  { id: 'elimination-chamber', name: 'Elimination Chamber' },
  { id: 'wrestlemania', name: 'WrestleMania', isFixed: true, week: 50 },
];

export const getPLELogo = (id) =>
  process.env.PUBLIC_URL + '/ples/' + id + '_logo.png';
